import {
    DAV_DATA_FAILED,
    DAV_DATA_LOADING,
    DAV_DATA_SUCCESS,
    SENT_LINK_FAILED,
    SENT_LINK_LOADING,
    SENT_LINK_SUCCESS,
    CHECK_STATUS_FAILED,
    CHECK_STATUS_LOADING,
    CHECK_STATUS_SUCCESS,
    SAVE_DAV_FAILED,
    SAVE_DAV_LOADING,
    SAVE_DAV_SUCCESS,
} from "../Constants/DAVConstants";

export const DAVReducer = (state = { DAVData: {} }, action) => {
    switch (action.type) {
      case DAV_DATA_LOADING:
        return { loading: true, DAVData: {} };
      case DAV_DATA_SUCCESS:
        return { loading: false, DAVData: action.payload };
      case DAV_DATA_FAILED:
        return { loading: false, error: action.DAVData };
      case SENT_LINK_LOADING:
        return {...state , loading: true , SentLinkData : {...action.payload}};
      case SENT_LINK_SUCCESS:
        return {...state , loading: false, SentLinkData : {...action.payload}};
      case SENT_LINK_FAILED:
        return {...state , loading: false, SentLinkData : {...action.payload}};
      case CHECK_STATUS_LOADING:
        return {...state , loading: true , StatusData : {...action.payload}};
      case CHECK_STATUS_SUCCESS:
        return {...state , loading: false, StatusData : {...action.payload}};
      case CHECK_STATUS_FAILED:
        return {...state , loading: false, StatusData : {...action.payload}};
      case SAVE_DAV_LOADING:
          return {...state , loading: true , SaveStatus : {...action.payload}};
      case SAVE_DAV_SUCCESS:
          return {...state , loading: false, SaveStatus : {...action.payload}};
      case SAVE_DAV_FAILED:
          return {...state , loading: false, SaveStatus : {...action.payload}};
      default:
        return state;
    }
  };